module.exports = __webpack_public_path__ + "media/images/icon_sort-11e7c4e9de972f05ed101ca6fe5fa983.svg";